module.exports = __webpack_public_path__ + "img/s_3.bfa73481.png";